import { parseDate } from "@internationalized/date";
import { HistoryOutline24Icon } from "@vygruppen/spor-icon-react";
import { FC } from "react";
import {
  DateRangePicker,
  DropsButton,
  Field,
  Flex,
  HStack,
  Input,
} from "shared/components/Spor";
import { useReasonCodesTableFilter } from "stores/useReasonCodesTableFilter";
import styled from "styled-components";

const FilterContainer = styled(HStack)`
  div {
    flex: min-content;
  }
  input {
    min-width: 100px;
    max-width: max-content;
  }
`;

const TableFilter: FC = () => {
  const {
    trainFilter,
    codeFilter,
    dateRange,
    setTrainFilter,
    setCodeFilter,
    setDateRange,
    reset,
  } = useReasonCodesTableFilter();
  return (
    <Flex p="18px" flexDir="column" gap="9px">
      <FilterContainer flexWrap="wrap">
        <Field maxWidth="max-content">
          <DateRangePicker
            variant="core"
            startLabel="Fra"
            endLabel="Til"
            aria-label="Dato"
            value={
              dateRange.start && dateRange.end
                ? {
                    start: parseDate(dateRange.start),
                    end: parseDate(dateRange.end),
                  }
                : null
            }
            onValueChange={(range) => {
              if (range) {
                setDateRange({
                  start: range.start?.toString() ?? undefined,
                  end: range.end?.toString() ?? undefined,
                });
              }
            }}
          />
        </Field>

        <Input
          label="Tognr"
          value={trainFilter}
          onChange={(e) => setTrainFilter(e.target.value)}
        />

        <Input
          type="number"
          label="Kode"
          value={codeFilter}
          onChange={(e) => setCodeFilter(e.target.value)}
        />
      </FilterContainer>
      <DropsButton
        size="sm"
        variant="tertiary"
        onClick={reset}
        leftIcon={<HistoryOutline24Icon />}
        marginRight="auto"
      >
        Nullstill filter
      </DropsButton>
    </Flex>
  );
};

export default TableFilter;
